import { processSteps } from '@/mocks/homeData';

export default function ProcessSection() {
  return (
    <section id="process" className="w-full bg-background-50 py-16 md:py-24">
      <div className="container-content">
        {/* Section header */}
        <div className="max-w-2xl mb-16 md:mb-20">
          <p className="font-label font-medium text-label-lg text-primary-600 tracking-wide uppercase mb-3">
            How It Works
          </p>
          <h2 className="font-heading text-display-md text-foreground-950 text-balance">
            Three steps. Zero hassle.
          </h2>
        </div>

        {/* Steps — editorial horizontal layout with large numbers */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {processSteps.map((step, index) => (
            <div
              key={step.number}
              className={`relative ${
                index === 1 ? 'md:mt-12' : ''
              } ${index === 2 ? 'md:mt-24' : ''}`}
            >
              {/* Large number */}
              <span className="font-heading font-bold text-[6rem] md:text-[7rem] leading-none text-background-200 select-none absolute -top-4 -left-2 md:-left-4">
                {step.number}
              </span>

              {/* Image */}
              <div className="relative z-10 mb-6">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-[280px] md:h-[320px] object-cover"
                />
              </div>

              {/* Text */}
              <h3 className="relative z-10 font-heading font-semibold text-heading-sm text-foreground-950 mb-2">
                {step.title}
              </h3>
              <p className="relative z-10 text-body-sm text-foreground-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}